module.exports = __webpack_public_path__ + "img/create2.0ff74d9e.gif";